export const config = {
  name: "Tokify",
  slogan: "Convert JSON & see GPT-4 tokens.",
  description:
    "A tool to convert JSON data into various formats and analyze their token usage with GPT-4 tokenization.",
  keywords: ["JSON", "LLM", "Tokenization", "GPT-4", "Formats", "Analyzer"],
  author: {
    name: "Toufiq Hasan Kiron",
    twitter: "https://twitter.com/hashtagkiron",
    email: "hello@kiron.dev",
    url: "https://kiron.dev",
  },
  url: "https://tokify.kiron.dev",
  ogImage: "/og.png",
}
